import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { scrollToId } from "@/hooks/useSmoothScroll";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "" }) => (
  <p
    className={`font-mono text-xs uppercase tracking-[0.22em] text-amber-800 font-semibold ${className}`}
  >
    {children}
  </p>
);

export const ArrowCta = ({ children, onClick, testId, className = "" }) => (
  <button
    type="button"
    data-testid={testId}
    onClick={onClick}
    className={`group inline-flex items-center gap-3 bg-[#C2410C] text-[#FBF9F5] font-sans font-semibold text-sm sm:text-base px-7 py-4 rounded-sm transition-colors duration-300 hover:bg-[#9A3412] focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#C2410C] ${className}`}
  >
    <span>{children}</span>
    <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
  </button>
);

export const scrollToForm = () => scrollToId("case-review");
